/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { MultipleInput } from "./modelMultipleInput";

class ControllerMultipleInput extends ControllerModel {
  constructor() {
    super("ControllerMultipleInput");

    this.setNewNode = (callback) => {
      let multipleInput = new MultipleInput();
      multipleInput.decorate(callback);
      this.addNode(multipleInput);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let multipleInput = new MultipleInput();
      multipleInput.copyFrom(node);
      multipleInput.decorate(callback);
      this.addNode(multipleInput);
    };

    this.getProperties = async (node) => {
      let n = new MultipleInput();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new MultipleInput();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerMultipleInput };
